import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import getBlobDuration from "get-blob-duration";

interface RecordVideoState {
    blobDuration: number;
    status: "idle" | "loading" | "succeeded" | "failed";
    error: string | null;
    canvasUrl: string;
    pausePlayback: boolean;
    isVideoRetakeModalOpen: boolean;
    isRecordVideoHelpModalOpen: boolean;
    isLoading: boolean;
    isVideoLossWarningModalOpen: boolean;
    isVideoLossWarningAvailable: boolean;
    initialVideoLength: number; 
    followUpVideoLength: number;
}

const initialState: RecordVideoState = {
    blobDuration: 0,
    status: "idle",
    error: null,
    canvasUrl: "",
    pausePlayback: true,
    isVideoRetakeModalOpen: false,
    isRecordVideoHelpModalOpen: false,
    isLoading: false,
    isVideoLossWarningModalOpen: false,
    isVideoLossWarningAvailable: false,
    initialVideoLength: 0, 
    followUpVideoLength: 0,
};

export const getBlobLength = createAsyncThunk(
  "recordVideo/getBlobLength",
  async ({ blob, videoType }: { blob: Blob, videoType?: string }) => {
    const blobDuration = await getBlobDuration(blob);
    return { duration: blobDuration, videoType };
  }
);

const {reducer, actions} = createSlice({
  name: "recordVideo",
  initialState,
  reducers: {
    setCanvasUrl: (state, action) => {
        state.canvasUrl = action.payload;
    },
    setPausePlayback: (state, action) => {
        state.pausePlayback = action.payload;
    },
    setIsLoading: (state, action) => {
        state.isLoading = action.payload;
    },
    setIsVideoRetakeModalOpen: (state, action) => {
        state.isVideoRetakeModalOpen = action.payload;
    },
    setIsRecordVideoHelpModalOpen: (state, action) => {
      state.isRecordVideoHelpModalOpen = action.payload;
    },
    resetRecordVideo: () =>  {
        return initialState;
    },
    setIsVideoLossWarningModalOpen  : (state, action) => {  
      state.isVideoLossWarningModalOpen = action.payload;
    },
    setIsVideoLossWarningAvailable  : (state, action) => {
      state.isVideoLossWarningAvailable = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBlobLength.fulfilled, (state, action) => {
      const { duration, videoType } = action.payload;
      if (videoType === "initial") {
        state.initialVideoLength = duration;
      } else if (videoType === "followUp") {
        state.followUpVideoLength = duration;
      }
    });
  },

});

export const {
    setCanvasUrl,
    setIsLoading,
    setIsRecordVideoHelpModalOpen,
    setIsVideoRetakeModalOpen,
    setIsVideoLossWarningModalOpen,
    setIsVideoLossWarningAvailable,
    setPausePlayback,
    resetRecordVideo,
} = actions;

export default reducer;

